//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconPartnerDashboard(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 3V20V21H3H22V19H4V3H2ZM6.04306 16.0393L9.68778 12.3946L13.6645 16.1214L21.9415 7.84439V5.01597L13.6645 13.2929L9.6878 9.56623L6.04309 13.2109L6.04306 16.0393Z" fill="currentColor" /></svg>;
}
export default IconPartnerDashboard;